// extracted by mini-css-extract-plugin
export default {"component":"CurrencyTextField_component__PzlBS","currencyLabelDiv":"CurrencyTextField_currencyLabelDiv__Ft2Jd"};